import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Key18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_609)'>
      <path
        d='M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.5 10.75C2.6005 10.75 0.25 8.3995 0.25 5.5C0.25 2.6005 2.6005 0.25 5.5 0.25C8.3995 0.25 10.75 2.6005 10.75 5.5V6.68928L17.0303 12.9696C17.171 13.1103 17.25 13.301 17.25 13.4999V17C17.25 17.1989 17.171 17.3897 17.0303 17.5303C16.8897 17.671 16.6989 17.75 16.5 17.75L12.5 17.7499C12.0858 17.7499 11.75 17.4142 11.75 16.9999V15.7499H10C9.58579 15.7499 9.25 15.4142 9.25 14.9999V12.8106L7.18934 10.7499L5.5 10.75ZM1.75 5.5C1.75 3.42893 3.42893 1.75 5.5 1.75C7.57107 1.75 9.25 3.42893 9.25 5.5V6.99994C9.25 7.19885 9.32902 7.38962 9.46967 7.53027L15.75 13.8106V16.25L13.25 16.2499V14.9999C13.25 14.5857 12.9142 14.2499 12.5 14.2499H10.75V12.4999C10.75 12.301 10.671 12.1103 10.5303 11.9696L8.03033 9.46961C7.88968 9.32896 7.69891 9.24994 7.5 9.24994L5.5 9.25C3.42893 9.25 1.75 7.57107 1.75 5.5Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_609'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Key18.displayName = 'Key18';
export default Key18;
